export const blockIconsCommunicationHubNew = (
	<span className='material-symbols-outlined'>hub</span>
);
